import React, { useEffect, useState } from "react";
import { Card, Col, Row, Flex } from "antd";
import CustomTitle from "../../../components/CustomTitle";
import CustomParagraph from "../../../components/CustomParagraph";
import LocalShipping from "../../../assets/images/20road.png";
import AirplaneFlying from "../../../assets/images/20air.png";

function ShipmentPreviewCard({ card, toggleDrawer, shipment }) {
  const [legs, setLegs] = useState([]);

  useEffect(() => {
    if (card?.legs_info?.legs?.length) {
      setLegs(card.legs_info.legs);
    } else {
      setLegs([]);
    }
  }, [card]);

  return (
    <Card
      style={{
        borderRadius: "12px",
        border: "2px solid #EEE",
        cursor: "pointer",
        height: "fit-content",
      }}
      bodyStyle={{ padding: "15px 15px" }}
      onClick={() => toggleDrawer("open", "Detail", card?.id)}
    >
      <Row gutter={[24, 16]} justify="space-between">
        <Col>
          <>
            <div
              style={{
                maxWidth: "200px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              <CustomTitle
                text={shipment.reference_number}
                fontSize={12}
                fontWeight={600}
                lineHeight="20px"
                color="#000"
                marginBottom="4px"
              />
              <CustomTitle
                text={"--"}
                fontSize={12}
                fontWeight={600}
                marginTop={10}
                lineHeight="20px"
                color="#000"
                marginBottom="4px"
              />
            </div>

            {/* 
            <Tag
              color={TagColor[type]}
              style={{
                borderRadius: "8px",
                color: TextColor[type],
                fontSize: "10px",
                width: "fit-content",
              }}
            >
         --
            </Tag> */}
          </>
        </Col>

        <Col>
          <CustomParagraph
            text={"--"}
            fontSize={12}
            fontWeight={500}
            color="#000"
            marginBottom="0"
          />

          <CustomParagraph
            text={shipment?.from_location?.name}
            fontSize={12}
            fontWeight={400}
            color="#4b4b4b"
            marginBottom="0"
          />
          <CustomParagraph
            text={"--"}
            fontSize={12}
            fontWeight={400}
            color="#4b4b4b"
            marginBottom="4px"
          />
        </Col>

        <Col>
          <Flex align="flex-end" vertical style={{ textAlign: "right" }}>
            <CustomParagraph
              text={"--"}
              fontSize={12}
              fontWeight={500}
              color="#000"
              marginBottom="0"
            />
            <CustomParagraph
              text={shipment.to_location.name}
              fontSize={12}
              fontWeight={400}
              color="#4b4b4b"
              marginBottom="0"
            />
            <CustomParagraph
              text={"--"}
              fontSize={12}
              fontWeight={400}
              color="#4b4b4b"
              marginBottom="4px"
            />
          </Flex>
        </Col>
      </Row>

      <Row className="shipment-progress" style={{ marginTop: "12px" }}>
        <Col span={24}>
          <Flex align="center">
            <ul className="custom-steps-display">
              {legs.length > 0 ? (
                legs.map((leg, index) => (
                  <li
                    key={index}
                    className={leg.status === "travelled" ? "active" : ""}
                    style={{
                      width: `${leg.distribution}%`,
                      marginRight: "4px",
                    }}
                  >
                    {leg.status === "travelled" && (
                      <div
                        className="centerImage"
                        style={{ backgroundColor: "#fff" }}
                      >
                        <img
                          src={
                            leg.mode === "truck"
                              ? LocalShipping
                              : AirplaneFlying
                          }
                          alt={leg.mode}
                          style={{ width: "20px" }}
                        />
                      </div>
                    )}
                  </li>
                ))
              ) : (
                <li style={{ width: "100%" }} />
              )}
            </ul>
          </Flex>
        </Col>
      </Row>
    </Card>
  );
}

export default ShipmentPreviewCard;
